/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Select_Next_EventInputs */



/**
* | output |
* | --- |
* | "Auto Select Next Event On Start Time Update" |
*
* @param {Options_Editor_Auto_Select_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_select_next_event = /** @type {((inputs?: Options_Editor_Auto_Select_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Select_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélection automatique du prochain événement lors de la mise à jour du TC de début")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Auswahl des nächsten Ereignisses bei Aktualisierung der Startzeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona automaticamente l'evento successivo all'aggiornamento dell'ora di inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматический выбор следующего события при обновлении времени начала.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar automáticamente el próximo evento al actualizar la hora de inicio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始时间更新时自动选择下一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始時間の更新時に次のイベントを自動選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारंभ समय अपडेट होने पर अगले इवेंट का स्वतः चयन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seleção automática do próximo evento na atualização da hora de início")
	return /** @type {LocalizedString} */ ("Auto Select Next Event On Start Time Update")
});